<template>
  <div class="card h-100 border-0 shadow-sm">
    <div class="card-body">
      <h5 class="card-title fw-bold">{{ title }}</h5>
      <div v-if="infoText" class="alert alert-info p-2 mb-3 d-flex align-items-center" style="background-color: #e0f2f1; border-color: #b2dfdb; color: #00695c;">
        <span class="fw-bold me-2">{{ infoIcon || '▲' }}</span> {{ infoText }}
      </div>
      <div :style="chartHeightStyle">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartCard',
  props: {
    title: { type: String, required: true },
    infoText: { type: String, default: null },
    infoIcon: { type: String, default: '▲' },
    chartHeight: { type: String, default: '300px' }
  },
  computed: {
    chartHeightStyle() {
      return { height: this.chartHeight }
    }
  }
}
</script>
